import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
    selector: "[app-roof-box]",
    templateUrl: "./roof-box.component.html",
    styleUrl: "./roof-box.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofBoxComponent {
  public x = input(0);
  public y = input(0);
  public width = input(200);
  public height = input(200);
  public hideLowerBox = input(false);
}
